import { Filter } from "@/shared/lib/filter/filter";
import { backendApi } from "../../api";
import { MatchOneToOne } from "../types/match";
import { MatchType } from "../types/match-type";

const matchOneToOneApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["BusinessCentralMatchOneToOne"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      businessCentralMatchOneToOnePut: build.mutation<
        MatchOneToOne,
        PutMatchOneToOneRequest
      >({
        query: (request) => ({
          url: `/business-central/match-one-to-one`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["BusinessCentralMatchOneToOne"],
      }),
      businessCentralMatchOneToOneShow: build.query<
        MatchOneToOne,
        ShowMatchOneToOneRequest
      >({
        query: (request) => ({
          url: `/business-central/match-one-to-one`,
          method: "GET",
          params: request,
        }),
        providesTags: ["BusinessCentralMatchOneToOne"],
      }),
      businessCentralMatchOneToOneList: build.query<
        List,
        ListOneToOneMatchRequest
      >({
        query: (request) => ({
          url: `/business-central/match-one-to-one/list`,
          method: "GET",
          params: { request: btoa(JSON.stringify(request)) },
        }),
        providesTags: ["BusinessCentralMatchOneToOne"],
      }),
      businessCentralMatchOneToOneDelete: build.mutation<
        void,
        DeleteMatchOneToOneRequest
      >({
        query: (request) => ({
          url: `/business-central/match-one-to-one`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["BusinessCentralMatchOneToOne"],
      }),
    }),
  });

export const {
  useBusinessCentralMatchOneToOnePutMutation,
  useBusinessCentralMatchOneToOneShowQuery,
  useBusinessCentralMatchOneToOneListQuery,
  useBusinessCentralMatchOneToOneDeleteMutation,
} = matchOneToOneApi;

export type PutMatchOneToOneRequest = MatchOneToOne;

export type ShowMatchOneToOneRequest = {
  type: MatchType;
  id: string;
};

export type List = { items: MatchOneToOne[]; count: number };

export type ListOneToOneMatchRequest = {
  type: Filter<MatchType>;
  limit?: number;
  offset?: number;
};

export type DeleteMatchOneToOneRequest = {
  type: MatchType;
  id: string;
};
